export default __webpack_public_path__ + "static/media/iconCard5.bdf1399e.svg";